/**
 * Meta Pixel Configuration
 * 
 * Pixel ID is public (visible in page source on any website using Meta Pixel)
 * This is separate from the CAPI token which remains secret in edge functions
 */
export const META_PIXEL_CONFIG = {
  pixelId: '185278563293894', // SULECLINIC Pikseli
} as const;
